module.exports = __webpack_public_path__ + "static/media/circleLogo.c7b2bad1.png";